/* global mainScript */
import React, { useRef } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

// style rules
import { Colors, Typography, Sizes } from "../../styles";

// const TicketDownload = ({ selectedSchool, selectedLanguage, ticket }) => {
const TicketDownload = ({ selectedSchool, ticket }) => {

	const scrollRef = useRef(null);

	const isMobile = useMediaQuery({
		query: `(max-width: ${Sizes.screens.medium})`,
	});

	// function that will scroll to the download form on mobile
	const scrollToDownloadOnMobile = () => {
		if (!isMobile) return;
		scrollRef.current.scrollIntoView({ behavior: "smooth" });
	};

	const renderTicket = () => {
		// if (ticket && selectedSchool && selectedLanguage) {
		if (ticket && selectedSchool) {
			scrollToDownloadOnMobile();
			return (
				<FormContainer>
					<div>
						<TicketIcon
							src={`${mainScript.assetPath}images/svg/icons/pass-admission-icon.svg`}
							alt=""
						/>
						<Ticket>
							<TicketTitle
								className="school-ticket-title"
								dangerouslySetInnerHTML={{ __html: ticket.title }}
							/>
							<TicketAges
								className="school-ticket-subtitle"
								dangerouslySetInnerHTML={{ __html: ticket.subtitle }}
							/>
							<TicketDetails
								dangerouslySetInnerHTML={{ __html: ticket.description }}
							/>
						</Ticket>
					</div>
					<DownloadButton
						href={ticket.linkUrl}
						target="_blank"
						className="link-arrow"
					>
						Download Pass
					</DownloadButton>
				</FormContainer>
			);
		} else {
			return (
				<FormContainer>
					<div>
						<TicketIcon
							src={`${mainScript.assetPath}images/svg/icons/pass-admission-icon.svg`}
							alt=""
						/>
					</div>
					<DownloadButton className="link-arrow" disabled>
						Download Pass
					</DownloadButton>
				</FormContainer>
			);
		}
	};

	return (
		<Wrapper ticket={ticket} ref={scrollRef}>
			<Title>2. Get your passes</Title>
			{renderTicket()}
		</Wrapper>
	);
};

export default TicketDownload;

TicketDownload.propTypes = {
	selectedSchool: PropTypes.string,
	// selectedLanguage: PropTypes.string,
	ticket: PropTypes.object,
};

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.5rem;
	opacity: ${(props) => (props.ticket ? "1" : "0.2")};
	pointer-events: ${(props) => (props.ticket ? "auto" : "none")};

	@media only screen and (min-width: ${Sizes.screens.large}) {
		flex: 0 0 326px;
		gap: 4rem;
	}
`;
const FormContainer = styled.div`
	background-color: ${Colors.base.white};
	padding: 2.4rem 2.7rem;
	margin: 0;
	height: 390px;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-start;
	position: relative;
`;
const Title = styled.h3`
	font-size: 2.4rem;
	line-height: 3rem;
	letter-spacing: -0.31px;
`;

const TicketIcon = styled.img`
	width: 38.47px;
	height: 38.47px;
`;

const Ticket = styled.div`
	margin-top: 1.4rem;
`;
const TicketTitle = styled.h4`
	font-weight: ${Typography.fontWeight.black};
	font-size: 2.6rem;
	line-height: 3rem;
	color: ${Colors.base.black};
`;
const TicketAges = styled.p`
	margin-top: 0.8rem;
	margin-bottom: 1.2rem;
	font-weight: ${Typography.fontWeight.medium};
	font-size: 1.4rem;
	line-height: 1.8rem;
`;
const TicketDetails = styled.p`
	font-weight: ${Typography.fontWeight.medium};
	font-size: 1.2rem;
	line-height: 2rem;
`;

const DownloadButton = styled.a``;
